"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSuggestedActions;

var _react = require("react");

var _WebChatReduxContext = require("../WebChatReduxContext");

var _useWebChatUIContext2 = _interopRequireDefault(require("./internal/useWebChatUIContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function useSuggestedActions() {
  var value = (0, _WebChatReduxContext.useSelector)(function (_ref) {
    var suggestedActions = _ref.suggestedActions;
    return suggestedActions;
  });

  var _useWebChatUIContext = (0, _useWebChatUIContext2.default)(),
      clearSuggestedActions = _useWebChatUIContext.clearSuggestedActions;

  return [value, (0, _react.useCallback)(function (value) {
    if (value && value.length) {
      throw new Error('SuggestedActions cannot be set to values other than empty.');
    }

    clearSuggestedActions();
  }, [clearSuggestedActions])];
}